export default __webpack_public_path__ + "static/media/sidebar-3.9992d0ce.jpg";